export default __webpack_public_path__ + "static/media/card-insta-suvinil3.c464cc55.jpg";